import { createFormAction } from 'redux-form-saga'

export const GET_ADMIN_DASHBOARD = 'GET_ADMIN_DASHBOARD'
export const GET_ADMIN_DASHBOARD_SUCCESS = 'GET_ADMIN_DASHBOARD_SUCCESS'
export const GET_ADMIN_DASHBOARD_FAILURE = 'GET_ADMIN_DASHBOARD_FAILURE'

export const getAdminDashboardAction = payload => ({
  type: GET_ADMIN_DASHBOARD,
  payload,
})
export const getAdminDashboardActionSuccess = payload => ({
    type: GET_ADMIN_DASHBOARD_SUCCESS,
    payload,
})
export const getAdminDashboardActionFailure = error => ({
    type: GET_ADMIN_DASHBOARD_FAILURE,
    error,
})
const getUserDashboardAction = createFormAction('GET_USER_DASHBOARD')
const getAllSiteImuNanoIotAction = createFormAction('GET_ALL_SITE_IMU_NANO_IOT')
const getImuDataAction = createFormAction('GET_IMU_DATA')

export {
  getUserDashboardAction,
  getAllSiteImuNanoIotAction,
  getImuDataAction,
}
